<script setup lang="ts">
// unused for now
</script>

<template>
  <div
    class="opacity-0 flex flex-col gap-2 min-w-[200px] p-3 bg-surface rounded-md shadow-md"
  >
    <!-- <button
      type="button"
      class="flex flex-nowrap items-center gap-2"
      @click="emits('logout')"
    >
      <Icon
        data="@/assets/icons/exit.svg"
        class="icon"
        original
        :fill="false"
        width="24"
        height="auto"
      />
      <span>Logout</span>
    </button> -->
  </div>
</template>

<style scoped></style>
